import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17f694c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "terminal",
  ref: "terminal"
}
const _hoisted_2 = { class: "dummyInput" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Command: ", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode()
const _hoisted_5 = {
  ref: "dummyInput",
  type: "text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmdInit = _resolveComponent("CmdInit")!
  const _component_ComponentPresenter = _resolveComponent("ComponentPresenter")!
  const _component_CommandLineInput = _resolveComponent("CommandLineInput")!
  const _component_LoadingPrint = _resolveComponent("LoadingPrint")!
  const _component_RecommendCommand = _resolveComponent("RecommendCommand")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CmdInit),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.commandExecutor.commandStack, (props, index) => {
      return (_openBlock(), _createBlock(_component_ComponentPresenter, {
        key: index,
        props: props
      }, null, 8, ["props"]))
    }), 128)),
    (!this.isExecuting)
      ? (_openBlock(), _createBlock(_component_CommandLineInput, {
          key: 0,
          dirPath: this.commandExecutor.currentDir,
          commandChars: this.keyboardHandler.getCommandChars(),
          cursorPosition: this.keyboardHandler.getCursorPosition()
        }, null, 8, ["dirPath", "commandChars", "cursorPosition"]))
      : (_openBlock(), _createBlock(_component_LoadingPrint, { key: 1 })),
    (!this.isExecuting)
      ? (_openBlock(), _createBlock(_component_RecommendCommand, {
          key: 2,
          recommends: this.commandExecutor.recommendations,
          onOnClick: this.onRecommendClick
        }, null, 8, ["recommends", "onOnClick"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("input", _hoisted_5, null, 512)
      ])
    ])
  ], 512))
}